const routes = [
  {
    path: "/manutencao-promotor-curso",
    name: "manutencao-promotor-curso",
    meta: {
      allowedPermissions: ["promotor_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDePromotorDeCursos/ManutencaoDePromotorDeCursosHome.vue"
      ),
  },
  {
    path: "/manutencao-promotor-curso/novo",
    name: "manutencao-promotor-curso-novo",
    meta: {
      allowedPermissions: ["promotor_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDePromotorDeCursos/ManutencaoDePromotorDeCursosCad.vue"
      ),
  },
  {
    path: "/manutencao-promotor-curso/editar/:id",
    name: "manutencao-promotor-curso-editar",
    meta: {
      allowedPermissions: ["promotor_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDePromotorDeCursos/ManutencaoDePromotorDeCursosEdit.vue"
      ),
  },
];

export default routes;
